import React, { useMemo } from 'react'

import { PhoneBlock, SelectWrapper, StyledCustomInput } from '../phone_v1/styled'
import Constants from 'helpers/constants'
import { PrefixSelect } from '../phone_v1/phone_v1'
import useOnChange from './hooks/use_on_change'

const countries = Constants.countriesPN

const PhoneV2 = ({ onChange, value, name, error, textAlign }) => {
  const code = value?.code
  const country = useMemo(() => countries.find((c) => c.prefix === code), [code])

  const { handleCodeChange, handleNumberChange } = useOnChange({ onChange, country, value })

  return (
    <PhoneBlock>
      <SelectWrapper>
        <PrefixSelect countries={countries} value={country} onChange={handleCodeChange} error={error} />
      </SelectWrapper>

      <StyledCustomInput
        type="input"
        name={name}
        placeholder="Enter phone number"
        value={value?.phone}
        error={error}
        textAlign={textAlign}
        onChange={handleNumberChange}
        autoComplete="tel-national"
      />
    </PhoneBlock>
  )
}

export default PhoneV2
